export default "__VITE_ASSET__pyhesOPz__"